import React, { memo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FlavourPreferenceSlider from '@components/FlavourPreferenceSlider';
import { useStyles } from './styles';

const SlidersList = ({ flavoursList, handleChangeFlavoursValue }) => {
  const classes = useStyles();

  return (
    <div>
      {flavoursList.map(item => (
        <Box key={item.id} className={classes.box}>
          <Typography className={classes.boxTitle}>{item.title}</Typography>
          <Typography className={classes.boxQuestion}>
            {item.question}
          </Typography>
          <FlavourPreferenceSlider
            id={item.id}
            left={item.left}
            right={item.right}
            value={item.valueSlider}
            handleChangeValueSlider={handleChangeFlavoursValue}
          />
        </Box>
      ))}
    </div>
  );
};

export default memo(SlidersList);
